"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var format_1 = __importDefault(require("date-fns/format"));
var lodash_1 = require("lodash");
var utils_1 = require("../../../utils");
var Checker_1 = __importDefault(require("../Checker"));
var constants_1 = require("./constants");
var RenderText = function (_a) {
    var value = _a.value;
    return react_1.default.createElement("span", null, value);
};
var RenderNumber = function (_a) {
    var value = _a.value;
    return react_1.default.createElement("span", { className: "number" }, value);
};
var RenderTextNumber = function (_a) {
    var value = _a.value;
    return react_1.default.createElement("span", null, value);
};
var RenderBoolean = function (_a) {
    var value = _a.value;
    return react_1.default.createElement(Checker_1.default, { value: value });
};
var RenderNull = function () { return react_1.default.createElement("span", null); };
var RenderEnum = function (_a) {
    var value = _a.value, column = _a.column;
    return (react_1.default.createElement("span", null, value ? lodash_1.get(column.enum.find(function (e) { return e.id === value; }), 'label', '') : ''));
};
var RenderRemoteEnum = function (_a) {
    var value = _a.value;
    return react_1.default.createElement("span", null, value);
};
var RenderDatetimeWithoutZone = function (_a) {
    var value = _a.value;
    return (react_1.default.createElement("span", null, value ? react_1.default.createElement("span", null, utils_1.formatDateWithoutZone(value)) : ''));
};
var RenderDatetime = function (_a) {
    var value = _a.value;
    return react_1.default.createElement("span", null,
        " ",
        value ? react_1.default.createElement("span", null, format_1.default(value, 'DD.MM.YYYY HH:mm')) : '',
        " ");
};
var RenderDate = function (_a) {
    var value = _a.value;
    return react_1.default.createElement("span", null,
        " ",
        value ? format_1.default(value, 'DD.MM.YYYY') : '',
        " ");
};
var RenderTime = function (_a) {
    var value = _a.value;
    return react_1.default.createElement("span", null,
        " ",
        value ? format_1.default(value, 'HH:mm') : '',
        " ");
};
exports.default = (function (_a) {
    var row = _a.row, column = _a.column, rest = __rest(_a, ["row", "column"]);
    var displayField = column.displayField, field = column.field, type = column.type, jsx = column.jsx, mapper = column.mapper;
    var fnMapper = mapper || lodash_1.identity;
    var value = fnMapper(row[displayField || field]);
    switch (type) {
        case constants_1.ColumnType.TEXT:
            return react_1.default.createElement(RenderText, { value: value });
        case constants_1.ColumnType.NUMBER:
            return react_1.default.createElement(RenderNumber, { value: value });
        case constants_1.ColumnType.TEXT_NUMBER:
            return react_1.default.createElement(RenderTextNumber, { value: value });
        case constants_1.ColumnType.ENUM:
            return react_1.default.createElement(RenderEnum, { value: value, column: column });
        case constants_1.ColumnType.REMOTE_ENUM:
            return react_1.default.createElement(RenderRemoteEnum, { value: value });
        case constants_1.ColumnType.BOOLEAN:
            return react_1.default.createElement(RenderBoolean, { value: value });
        case constants_1.ColumnType.DATETIME:
            return react_1.default.createElement(RenderDatetime, { value: value });
        case constants_1.ColumnType.DATETIMEWITHOUTZONE:
            return react_1.default.createElement(RenderDatetimeWithoutZone, { value: value });
        case constants_1.ColumnType.DATE:
            return react_1.default.createElement(RenderDate, { value: value });
        case constants_1.ColumnType.TIME:
            return react_1.default.createElement(RenderTime, { value: value });
        case constants_1.ColumnType.JSX:
            if (!(jsx instanceof Function)) {
                console.warn('jsx property is required e.g. jsx: (row) => <span>{row.name}</span>'); // eslint-disable-line no-console
                return false;
            }
            var JSX = jsx;
            return react_1.default.createElement(JSX, { row: row, column: column, gridProps: rest });
        default:
            return react_1.default.createElement(RenderNull, null);
    }
});
//# sourceMappingURL=Value.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Value.js
// module id = 2214
// module chunks = 0